import { TenantSelectPage } from 'src/app/pages/auth/tenant-select/tenant-select.page';
import { CapturePage } from 'src/app/pages/capture/capture.page';
import { GoPage } from 'src/app/pages/go/go.page';
import { PrintJobsPage } from 'src/app/pages/print-jobs/print-jobs.page';
import { PrinterListPage } from 'src/app/pages/printer-list/printer-list.page';
import { RegisterNfcTagPage } from 'src/app/pages/register-nfc-tag/register-nfc-tag.page';
import { ReleaseHistoryPage } from 'src/app/pages/release-history/release-history.page';
import { CaptureHistoryPage } from 'src/app/pages/capture-history/capture-history.page';
import { IMenuItem } from './menu-item.model';

export const MenuItems: IMenuItem[] = [
  {
    title: 'SignIn',
    component: null,
    route: null,
    navParams: {},
    icon: 'icon-sign-in',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: false,
    showIfNotAuthenticated: true,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Print',
    component: PrintJobsPage,
    route: '/print-jobs',
    navParams: {},
    icon: 'icon-print',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Printers',
    component: PrinterListPage,
    route: '/printer-list',
    navParams: {},
    icon: 'icon-printer',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Capture',
    component: CapturePage,
    route: '/capture',
    navParams: {},
    icon: 'icon-capture',
    showIfNotCordova: false,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Recents',
    component: PrintJobsPage,
    route: '/recents',
    navParams: {},
    icon: 'icon-clock',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'PrintHistory',
    component: ReleaseHistoryPage,
    route: '/release-history',
    navParams: {},
    icon: 'icon-history',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'CaptureHistory',
    component: CaptureHistoryPage,
    route: '/capture-history',
    navParams: {},
    icon: 'icon-history',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true,
  },
  {
    title: 'CardsAndCodes',
    component: GoPage,
    route: '/go',
    navParams: {},
    icon: 'icon-access-card-2',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'ChangeHome',
    component: TenantSelectPage,
    route: '/tenant-select',
    navParams: { changeHome: true },
    icon: 'icon-home',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true,
  },
  {
    title: 'PrinterIdMethod',
    component: null,
    route: null,
    navParams: {},
    icon: 'icon-secure-print-sm',
    showIfNotCordova: false,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true,
  },
  {
    title: 'RegisterNfcTag',
    component: RegisterNfcTagPage,
    route: '/register-nfc-tag',
    navParams: {},
    icon: 'icon-nfc-chip',
    showIfNotCordova: false,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true,
  },
  {
    title: 'AirPrintPassword',
    component: null,
    route: null,
    navParams: {},
    icon: 'icon-lock',
    showIfNotCordova: false,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Diagnostics',
    component: null,
    route: null,
    navParams: {},
    icon: 'icon-diagnostics',
    showIfNotCordova: false,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: true,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Language',
    component: null,
    route: null,
    navParams: {},
    icon: 'icon-language',
    showIfNotCordova: true,
    languageMenuToggle: true,
    showIfAuthenticated: true,
    showIfNotAuthenticated: true,
    showIfInternetIsAvailable: true
  },
  {
    title: 'Help',
    component: null,
    route: null,
    navParams: '{{"UrlUserManual" | translate}}',
    icon: 'icon-help',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: true,
    showIfInternetIsAvailable: true
  },
  {
    title: 'SignOut',
    component: null,
    route: null,
    navParams: {},
    icon: 'icon-sign-out',
    showIfNotCordova: true,
    languageMenuToggle: false,
    showIfAuthenticated: true,
    showIfNotAuthenticated: false,
    showIfInternetIsAvailable: true
  }
];

export const list = [
'SignIn',           // all platforms, not authenticated
'Print',            // all platforms, authenticated
'Printers',         // all platforms, authenticated
'Capture',          // all platforms, authenticated
'Recents',          // all platforms, authenticated
'PrintHistory',     // all platforms, authenticated
'CaptureHistory',   // all platforms, authenticated
'CardsAndCodes',    // all platforms, authenticated
'ChangeHome',       // all platforms, authenticated, user got multiple tenants
'PrinterIdMethod',  // Cordova only, authenticated
'RegisterNfcTag',   // Cordova only, authenticated
'AirPrintPassword', // iOS only, authenticated
'Diagnostics',      // Cordova only, always shown
'Language',         // all platforms, always shown
'Help',             // all platforms, always shown
'SignOut',          // all platforms, authenticated
]